import { ErrorTrade } from './ErrorTrade';

export class ErrorTradeResponse {
  id: number;
  source: string;
  goldenRecordUniqueId: string;
  accountId: number;
  serialId: number;
  errorCode: string;
  manualReconciliationResult: string;
  goldenRecordErrorTrade: ErrorTrade;
  abosErrorTrade: ErrorTrade;
}
